import { Row, Spin } from 'antd';
import React from 'react';

export default function ComponentSpinner(props) {
  return (
    <Row
      justify="center"
      align="middle"
      className={props.className || 'whole-page'}
    >
      <Spin />
    </Row>
  );
}
